// Reuse the existing app embed through its public event only.
(() => {
  if (window.umakerJohnCtaBound) return;
  window.umakerJohnCtaBound = true;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('[data-umaker-john-open]')) return;
    window.dispatchEvent(new CustomEvent('umaker:john:open'));
  });
})();
